import React, { useState, useEffect } from 'react';
import './ChatbotAvatar.css';
import chatbotIcon from '../../assets/icons/chatbot.svg';
import peanutIcon from '../../assets/icons/peanut.svg';
import { useDynamicColors } from '../../utils/dynamicColors';
import { getBotName } from '../../utils/dynamicCityName';

interface ChatbotAvatarProps {
  showInitialMessage?: boolean;
  messageDelay?: number;
  onClick?: () => void;
}

const ChatbotAvatar: React.FC<ChatbotAvatarProps> = ({ 
  showInitialMessage = true, 
  messageDelay = 800,
  onClick
}) => {
  const [showMessage, setShowMessage] = useState(false);
  const { currentCommunity } = useDynamicColors();
  const botName = getBotName(currentCommunity);

  useEffect(() => {
    if (showInitialMessage) {
      // Show message after a short delay
      const messageTimer = setTimeout(() => {
        setShowMessage(true);
      }, messageDelay);
      
      return () => {
        clearTimeout(messageTimer);
      };
    }
  }, [showInitialMessage, messageDelay]);

  const handleAvatarClick = () => {
    // Hide the message bubble when modal is opened
    setShowMessage(false);
    
    // Call the onClick prop if provided
    if (onClick) {
      onClick();
    }
  };

  // Modal is now handled by parent component

  return (
    <div className="chatbot-container">
      {showMessage && (
        <div className="chatbot-message" style={{ transition: 'all 0.6s ease-out' }}>
          {currentCommunity === 'aubrey-tx' ? (
            <>
              <p>Hi, I'm <b style={{ fontWeight: 'bold' }}>{botName}</b>, the City's new <b style={{ fontWeight: 'bold' }}>AI companion</b>. I'm designed to answer questions about planning, zoning, and land use, helping you quickly find the information you need.</p>
            </>
          ) : (
            <>
              <p>Hi, I am <b style={{ fontWeight: 'bold' }}>{botName}</b> - city's new  <b style={{ fontWeight: 'bold' }}>AI companion</b>.</p>
              <p>I am trained to answer questions around Planning, Zoning and Land Use.</p>
            </>
          )}
        </div>
      )}
      <div className="chatbot-avatar" onClick={handleAvatarClick}>
        <img src={currentCommunity === 'aubrey-tx' ? peanutIcon : chatbotIcon} alt="Koby AI Chatbot" className={`chatbot-icon ${currentCommunity === 'aubrey-tx' ? 'peanut-icon' : ''}`} />
      </div>
    </div>
  );
};

export default ChatbotAvatar;
